import { consola } from 'consola';
import type { CartItem } from '../model/types';
import { LOCAL_STORAGE_CART_KEY, MAX_CART_ITEMS } from '@shared/config';

// Logger от Nuxt (consola)
const logger = consola.withTag('cart-persistence');

export const loadCartFromStorage = (): CartItem[] => {
  if (!process.client) return [];

  try {
    const savedCart = localStorage.getItem(LOCAL_STORAGE_CART_KEY);
    return savedCart ? JSON.parse(savedCart) : [];
  } catch (error) {
    logger.error('Cart parse error', error);
    clearCartStorage();
    return [];
  }
};

export const saveCartToStorage = (items: CartItem[]): void => {
  if (!process.client || items.length > MAX_CART_ITEMS) return;

  try {
    localStorage.setItem(LOCAL_STORAGE_CART_KEY, JSON.stringify(items));
  } catch (error) {
    logger.error('Cart save error', error);
    if ((error as Error).name === 'QuotaExceededError') {
      alert('Cart is too large. Some items may not be saved.');
    }
  }
};

export const clearCartStorage = (): void => {
  if (!process.client) return;
  localStorage.removeItem(LOCAL_STORAGE_CART_KEY);
};